export const isAuthInitializedSelector = (state) => state.auth.isLogged !== undefined;

export const isLoggedSelector = (state) => state.auth.isLogged;

export const userSelector = (state) => state.auth.user;
